<elements-stoplight-project
  [projectId]="externalProjectId"
  hideMocking="true"
  collapseTableOfContents="true"
  router="hash"
  hideExport="true"
></elements-stoplight-project>

<!--<div class="iframe-container">-->
<!--  <iframe width="100%" height="100%" [src]="iframeUrl"></iframe>-->
<!--</div>-->
